import { ColOptions } from 'src/app/shared/basic/ds-col/ds-col.component';
import { DsTableColumnOverrideEnum } from './TableColumn';

export interface DsTableColumnConfig {
  key?: string;
  property?: string;
  modelType?: string;
  displayProperty: string;
  label?: string;
  format?: DsTableColumnFormatEnum;
  displayPosition?: DsTableColumnDisplayPosition;

  /**
   * used for table main columns
   */
  size?: DsTableColumnSizeEnum;

  /**
   * used for details section only
   * NOT used for main columns
   */
  responsiveSize?: ColOptions;

  /**The order of the column in the table & details section */
  sequence?: number;

  /**Property override options */
  override?: DsTableColumnOverrideEnum;
}

export enum DsTableColumnFormatEnum {
  Text = 'text',
  Date = 'date',
  Lookup = 'lookup',
  Object = 'object',
}

export enum DsTableColumnDisplayPosition {
  Header = 'header',
  Details = 'details',
}

export enum DsTableColumnSizeEnum {
  Twenty = '20%',
  Third = '30%',
  Forty = '40%',
  Fifty = '50%',
  Ninety = '90%',
}
